import { render } from "./ProductFilter.vue?vue&type=template&id=6ff1d8ec"
import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-submission/components/filter/ProductFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ff1d8ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ff1d8ec', __exports__)) {
    api.reload('6ff1d8ec', __exports__)
  }
  
  module.hot.accept("./ProductFilter.vue?vue&type=template&id=6ff1d8ec", () => {
    api.rerender('6ff1d8ec', render)
  })

}


export default __exports__